import React, { useEffect, useState, useSyncExternalStore } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

import ForgotPassword from "./pages/ForgotPassword";
import {subscribeSignupProvisioning, getSignupProvisioning} from "./services/signupProvisioning";
import Navbar from "./components/Navbar";
import MainPage from "./pages/MainPage";
import JanakpuriBooking from "./pages/JanakpuriBooking";
import Booking from "./pages/Booking";
import AdminLogin from "./pages/AdminLogin";
import HotelManagerLogin from "./pages/HotelManagerLogin";
import HotelManagerDashboard from "./pages/HotelManagerDashboard";
import AdminPanel from "./pages/AdminPanel";
import PrivateRoute from "./components/PrivateRoute";
import AuthPage from "./pages/AuthPage";

function AppContent() {
  const location = useLocation();
  const provisioning = useSyncExternalStore(subscribeSignupProvisioning, getSignupProvisioning);

  const [user, setUser] = useState(undefined);

  // Navbar in pages par show nahi hoga
  const hideNavbarOn = [
    "/",
    "/login",
    "/signup",
    "/booking",
    "/admin",
    "/main",
    "/manager-dashboard"
  ];

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
    });

    return () => unsub();
  }, []);

  if (user === undefined || provisioning) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

  return (
    <>
      {!hideNavbarOn.includes(location.pathname) && <Navbar />}

      <Routes>
        <Route
          path="/"
          element={user ? <Navigate to="/main" replace /> : <AuthPage />}
        />

        <Route
          path="/login"
          element={user ? <Navigate to="/main" replace /> : <AuthPage />}
        />

        <Route
          path="/signup"
          element={user ? <Navigate to="/main" replace /> : <AuthPage />}
        />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/manager-login" element={<HotelManagerLogin />} />
        <Route path="/admin" element={<AdminLogin />} />

        <Route element={<PrivateRoute />}>
          <Route path="/main" element={<MainPage />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/janakpuri" element={<JanakpuriBooking />} />
          <Route
            path="/manager-dashboard"
            element={<HotelManagerDashboard />}
          />
          <Route path="/admin-panel" element={<AdminPanel />} />
        </Route>

        <Route
          path="*"
          element={<Navigate to={user ? "/main" : "/"} replace />}
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;